import BaseWidget from '@/plugins/dashboard/classes/BaseWidget'
import widgets from '@/plugins/dashboard/widgets'
import { fetchData, setChartDataBackgroundColours, setOptionsForChartType } from '@/plugins/dashboard/widgets/utils'
import get from 'lodash/get'

export default class Chart extends BaseWidget {
  get data () {
    return new Promise(async (resolve) => {
      let chartData = {
        datasets: [
          ...await this.dataset
        ],
        labels: this.labels
      }

      if (this.configuration.comparing) {
        for (let widget of this.configuration.comparing) {
          const stackedWidget = new widgets[widget.name](widget.configuration)
          chartData.datasets.push(...await stackedWidget.dataset)
        }
      }

      chartData = setChartDataBackgroundColours(chartData)
      chartData = setOptionsForChartType(chartData)
      chartData.scales = {
        xAxes: [{
          stacked: true
        }],
        yAxes: [{
          stacked: true
        }]
      }

      resolve(chartData)
    })
  }

  get props () {
    return Object.assign({}, this.configuration, {
      minW: get(this.configuration, 'minW', '3'),
      minH: get(this.configuration, 'minH', '3')
    })
  }

  get dataset () {
    return new Promise(async (resolve) => {
      resolve(await fetchData(this.configuration))
    })
  }

  get labels () {
    return this.configuration.labels
  }
}
